import { createI18n } from 'vue-i18n'
import enUS from './en-US.json'
import zhCN from './zh-CN.json'

export const SUPPORTED_LOCALES = ['en-US', 'zh-CN'] as const
const DEFAULT_LOCALE: TSupportedLocale = 'en-US'

function detectLocale (): TSupportedLocale {
  const resolveLocale = (value: string) => {
    return SUPPORTED_LOCALES.find(locale => locale === value || locale.split('-')[0] === value?.split('-')[0]) ?? DEFAULT_LOCALE
  }

  const deviceLang = navigator.language

  return resolveLocale(deviceLang)
}

export const i18n = createI18n<[TTranslationMessageSchema], TSupportedLocale, false>({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { 'en-US': enUS, 'zh-CN': zhCN }
})

export function setLocale (locale: TSupportedLocale) {
  i18n.global.locale.value = locale
}
